// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Box, Stack, Typography } from '@metarouter-private/mr-mui';
import IntegrationAvatarGroup from 'app/shared/components/integrations/IntegrationAvatarGroup';
import TimeAgoAndDate from 'app/components/TimeAgoAndDate';

export default function FileRow({ file, isSelected, onToggle }) {
  const pipelineName = file.pipeline?.name ?? 'Unknown Pipeline';
  const identitySyncs =
    file.identitySyncs?.map(sync => ({
      starterkitId: sync.identity_sync?.name,
      name: sync.identity_sync?.friendlyName,
    })) ?? [];

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
        '&:last-child': { borderBottom: 0 },
        '&:hover': { bgcolor: 'action.hover' },
        cursor: 'pointer',
      }}
      onClick={onToggle}
      data-testid={`file-row-${file.id}`}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Checkbox checked={isSelected} onChange={onToggle} onClick={event => event.stopPropagation()} />
        <Typography variant="body1" fontWeight={500} noWrap sx={{ flex: 1, minWidth: 0 }}>
          {pipelineName}
        </Typography>
        {identitySyncs.length > 0 && <IntegrationAvatarGroup integrations={identitySyncs} max={5} size="small" />}
        {file.updatedAt && (
          <Stack spacing={0} sx={{ minWidth: 140, textAlign: 'right' }}>
            <Typography variant="caption" color="text.secondary">
              Last updated:
            </Typography>
            <TimeAgoAndDate
              timestamp={file.updatedAt}
              TimeAgoProps={{ TypographyProps: { variant: 'caption', color: 'text.secondary' } }}
            />
          </Stack>
        )}
      </Stack>
    </Box>
  );
}

FileRow.propTypes = {
  file: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
